"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBarComponent = void 0;
var widgets_1 = require("@tableau/widgets");
var d3 = require("d3");
var React = require("react");
var react_1 = require("react");
var Info_1 = require("../icons/Info");
var styles = require("../styles/PredictionModelResultsViz");
var colors = require("../util/colors");
var sizes = require("../util/sizes");
var utils_1 = require("../util/utils");
var PredictionModelVizCardButton_1 = require("./PredictionModelVizCardButton");
var ProgressBarComponent = function (props) {
    var metricName = props.metricName, value = props.value, tooltipContent = props.tooltipContent, minLabel = props.minLabel, maxLabel = props.maxLabel, title = props.title, description = props.description, buttonLabel = props.buttonLabel, onButtonClick = props.onButtonClick, hideBorder = props.hideBorder, isRounded = props.isRounded, showBarLabel = props.showBarLabel, color = props.color;
    var getToolTipContent = function () { return React.createElement("span", null, tooltipContent); };
    var chartRef = react_1.useRef(null);
    // TODO: Figure out how to handle sizing and resizing
    var barWidth = sizes.widthRegular; // or progress bar
    var height = 30; // of bar
    var barHeight = height / 2;
    var xScale = d3.scaleLinear().domain([0, 1]).rangeRound([0, barWidth]);
    var drawBar = react_1.useCallback(function (color, width) {
        d3.select(chartRef.current)
            .append('rect')
            .attr('rx', isRounded ? barHeight / 2 : 0)
            .attr('ry', isRounded ? barHeight / 2 : 0)
            .attr('fill', color)
            .attr('height', barHeight)
            .attr('width', width)
            .attr('x', 0);
    }, [barHeight, isRounded]);
    // Inside bar
    var drawBarLabel = react_1.useCallback(function () {
        // TODO: Change color to black or white depending on background color!
        // TODO: Check if there's enough space to even render the label
        d3.select(chartRef.current)
            .append('text')
            .text(value)
            .attr('font-size', barHeight / 2)
            .attr('fill', 'white')
            .attr('dy', '1.5em')
            .attr('y', barHeight + 5) // TODO: Adjust label positioning
            .attr('x', (xScale(value) || 0) - 5)
            .style('text-anchor', 'end');
    }, [barHeight, xScale, value]);
    react_1.useEffect(function () {
        d3.select(chartRef.current).selectAll('*').remove(); // To avoid stacking svg every re-render
        var svg = d3.select(chartRef.current).attr('width', barWidth).attr('height', height);
        drawBar(colors.veryLightGray, barWidth);
        drawBar(color || colors.defaultBlue, xScale(value) || 0);
        // draw axis
        var axis = utils_1.getLinearAxis(xScale, utils_1.AxisPosition.Bottom);
        utils_1.formatAxis(axis, sizes.defaultNumTicks, sizes.defaultTickSize, 3, utils_1.TickFormat.progressBar);
        utils_1.drawAxis(svg, axis, 0, barHeight + 5);
        if (showBarLabel) {
            drawBarLabel();
        }
    }, [color, drawBar, drawBarLabel, xScale, showBarLabel, value, barWidth, barHeight]);
    return (React.createElement("div", { className: hideBorder ? styles.cardContainer : styles.cardContainer + ' ' + styles.cardBorderShadow },
        React.createElement("div", { className: hideBorder ? styles.card : styles.cardBorder + ' ' + styles.card },
            title && React.createElement("label", { className: styles.cardTitle }, title),
            description && React.createElement("label", { className: styles.cardDescription }, description),
            React.createElement("div", { className: styles.progressBarHeader },
                React.createElement("div", { className: styles.progressBarHeaderLeft },
                    React.createElement("label", { className: styles.progressBarHeaderText }, metricName),
                    tooltipContent && (React.createElement(widgets_1.Tooltip, { getContent: getToolTipContent },
                        React.createElement("span", null, React.createElement(Info_1.Info, null))))),
                React.createElement("label", { className: styles.progressBarHeaderText }, value)),
            React.createElement("div", { className: styles.progressBarLabels },
                React.createElement("label", null, minLabel),
                React.createElement("label", null, maxLabel)),
            React.createElement("svg", { ref: chartRef })),
        onButtonClick && buttonLabel && React.createElement(PredictionModelVizCardButton_1.PredictionModelVizCardButton, { onClick: onButtonClick, label: buttonLabel })));
};
exports.ProgressBarComponent = ProgressBarComponent;
//# sourceMappingURL=ProgressBarComponent.js.map